import React from "react";



// Blog.jsx
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { blogPosts } from "../Blog/data/blogPost";

function Blog() {
  return (
    <div className="bg-white text-[#1A3C34] font-sans">
      <Navbar />

      <main className="max-w-7xl mx-auto px-6 py-24">
        <h1 className="text-4xl md:text-6xl font-bold italic uppercase text-center mb-12">
          <span className="bg-[#F9C93F] text-black italic px-4 py-1 rounded">The Journal</span>
        </h1>

        <div className="grid md:grid-cols-2 gap-10">
          {blogPosts.map((post) => (
            <div
              key={post.id}
              className="bg-[#fdfdfb] border border-[#ddd] rounded-2xl p-6 shadow-md hover:shadow-xl transition-shadow duration-300"
            >
              <h2 className="text-2xl font-bold mb-2">{post.title}</h2>
              <p className="text-sm text-gray-500 mb-3">{post.date}</p>
              <p className="text-gray-700 mb-4">{post.excerpt}</p>
              <Link
                to={`/blog/${post.id}`}
                className="inline-block text-sm bg-[#F9C93F] border border-black text-black px-5 py-2 rounded-full font-semibold hover:bg-black hover:text-white transition-colors duration-300"
              >
                Read More
              </Link>
            </div>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Blog;
